/**
 * Application constants
 */

export const APP_NAME = 'VoxaPilot';
export const APP_VERSION = '0.1.0';

// Routes
export const ROUTES = {
  // Landing (public)
  HOME: '/',
  PRICING: '/pricing',
  ENTERPRISE: '/enterprise',
  FEATURES: '/features',

  // Auth (public)
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  FORGOT_PASSWORD: '/forgot-password',

  // Blog/Resources (public)
  BLOG: '/blog',
  BLOG_POST: (slug: string) => `/blog/${slug}`,
  RESOURCES: '/resources',
  INTEGRATIONS: '/integrations',
  SECURITY: '/security',
  ABOUT: '/about',
  CONTACT: '/contact',
  CAREERS: '/careers',
  HELP_CENTER: '/help-center',
  API: '/api',
  PRIVACY: '/privacy',
  TERMS: '/terms',

  // App (protected)
  APP: '/app',
  APP_MEETINGS: '/app/meetings',
  MEETINGS: '/meetings', // Alias
  MEETING_DETAIL: (id: string) => `/meetings/${id}`,
  APP_MEETING_DETAIL: (id: string) => `/app/meetings/${id}`,
  PROFILE: '/profile',
  APP_PROFILE: '/app/profile',
  SETTINGS: '/settings',
  APP_SETTINGS: '/app/settings',

  // Onboarding (protected)
  ONBOARDING: '/onboarding',
  ONBOARDING_WELCOME: '/onboarding/welcome',
  ONBOARDING_PROFILE: '/onboarding/profile',
  ONBOARDING_FIRST_MEETING: '/onboarding/first-meeting',
  ONBOARDING_FEATURES: '/onboarding/features',
  ONBOARDING_COMPLETE: '/onboarding/complete',

  // Study Mode (public landing)
  STUDY_MODE: '/study',
  STUDY_MODE_FEATURES: '/study#features',
  STUDY_MODE_PRICING: '/study/pricing',

  // Study Mode App (protected)
  STUDY_APP: '/study/app',
  STUDY_DOCUMENTS: '/study/app/documents',
  STUDY_DOCUMENT_DETAIL: (id: string) => `/study/app/documents/${id}`,
  STUDY_CHAT: '/study/app/chat',
  STUDY_FLASHCARDS: '/study/app/flashcards',
  STUDY_ANALYTICS: '/study/app/analytics',
} as const;

